import { useEffect, useState } from "react";

export function usePathname() {
  const [path, setPath] = useState<string>(typeof location !== "undefined" ? location.pathname : "/");
  useEffect(() => {
    const onPop = () => setPath(location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  return path;
}

export function navigate(to: string) {
  if (location.pathname === to) return;

  // Store current page as previous page before navigating
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.setItem("previousPage", location.pathname);
  }

  history.pushState({}, "", to);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function usePreviousPage() {
  const [previousPage, setPreviousPage] = useState<string | null>(null);

  useEffect(() => {
    // Try to get from sessionStorage first
    const stored = typeof sessionStorage !== "undefined" ? sessionStorage.getItem("previousPage") : null;
    if (stored) {
      setPreviousPage(stored);
      return;
    }

    // Fallback to document.referrer
    if (typeof document !== "undefined" && document.referrer) {
      try {
        const referrerUrl = new URL(document.referrer);
        if (referrerUrl.origin === location.origin) {
          setPreviousPage(referrerUrl.pathname);
        }
      } catch {
        // Invalid referrer URL
      }
    }
  }, []);

  return previousPage;
}
